import { normalize } from 'duration-fns'

import State from '$lib/utils/state.svelte.js'

let formatter = $derived(
  new Intl.DurationFormat(State.language, { style: 'narrow' })
)

export * from 'duration-fns'

/**
 * @typedef {Object} DurationInput
 * @property {number} [years]
 * @property {number} [months]
 * @property {number} [weeks]
 * @property {number} [days]
 * @property {number} [hours]
 * @property {number} [minutes]
 * @property {number} [seconds]
 * @property {number} [milliseconds]
 * @property {number} [microseconds]
 * @property {number} [nanoseconds]
 */

/** @param {DurationInput} input */
export function format(input) {
  return formatter.format(normalize(input))
}
